import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';

import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { Link } from 'react-router';
import MyStableUnauthenticatedUser from '../components/MyStableUnauthenticatedUser';

import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableCross from 'modules/Common/containers/Subscriptions/MyStableCross';

require('./MyStableSelections.scss');

@standardAsyncConnect([
  userServiceLayoutConnect({
    state: state => ({auth: state.common.auth, subscriptions: state.common.userService.subscriptions})
  })
])
@catchLifeCycleErrors
export default class MyStableSelections extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    subscriptions: PropTypes.object.isRequired
  }

  render() {
    if (!this.props.isLoggedIn()) {
      return <MyStableUnauthenticatedUser/>
    }

    const subscriptionTypes = [
      {type: 'HORSE', label: 'Horse', profileUrl: id => `/racing/profiles/horse/${id}`},
      {type: 'JOCKEY', label: 'Jockey', profileUrl: id => `/racing/profiles/jockey/${id}`},
      {type: 'TRAINER', label: 'Trainer', profileUrl: id => `/racing/profiles/trainer/${id}`}
    ];

    const {
      subscriptions = {}
    } = this.props;

    const filteredSubscriptions = subscriptionTypes.filter(subscriptionType =>
      Object.keys(subscriptions[subscriptionType.type] || {}).length);

    return (
      <section className="userSelections">
        <MetaDataWrapper title="Your Selections"/>
        <h3 className="my-stable-subtitle section-title">Your Selections</h3>
        <p className="my-stable-selections-info"><small>You may select a maximum of 100 Horses, 10 Jockeys and 10 Trainers for e-mail updates.</small></p>
        <div className="my-stable-selections">
          {
            filteredSubscriptions.length > 0 ?
              filteredSubscriptions.map(subscriptionType =>
                <div className="my-stable-selection-section" key={subscriptionType.type}>
                  <div className="my-stable-section-header">
                    <span className="my-stable-section-header-key" id={"my-stable-"+subscriptionType.label}>{subscriptionType.label}</span>
                    <span className="my-stable-section-header-remove"></span>
                  </div>
                  <table className="my-stable-table">
                    <tbody>
                      {
                        Object.keys(subscriptions[subscriptionType.type]).map( (id) =>
                          <tr key={ id }>
                            <td className="my-stable-selection-table-key-name">
                              <Link to={subscriptionType.profileUrl(id)}>
                                { subscriptions[subscriptionType.type][id].text }
                              </Link>
                            </td>
                            <td className="my-stable-selection-table-key-remove">
                              <SubscriptionContainer
                                addSubscriptions={
                                  [{
                                    type: subscriptionType.type,
                                    id,
                                    text: subscriptions[subscriptionType.type][id].text
                                  }]
                                }
                                icon={ <MyStableCross /> }
                              />
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                </div>
              )
          :
            <div className="my-stable-selection-none">
              <span>You haven't made any selections for 'My Stable'. Begin by searching for your favourite horse, jockey or trainer.</span>
            </div>
          }
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStableSelections.js